import { Component, HostListener, Inject } from '@angular/core'
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms'
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog'

@Component({
  selector: 'app-edit-note-dialog',
  templateUrl: './edit-note-dialog.component.html',
  styleUrls: ['./edit-note-dialog.component.scss'],
  standalone: false,
})
export class EditNoteComponent {
  confirmForm: FormGroup

  cancel = 'Cancel'
  confirm = 'Delete'
  showMessage = true
  showCancel = true
  reasonRequired = false

  focus = {
    reason: false,
  }

  public errorMessages = {
    reason: [{ type: 'required', message: 'At least one character is required.' }],
  }

  /* istanbul ignore next */
  @HostListener('document:keyup.enter', ['$event']) onEnterHandler(event: KeyboardEvent) {
    this.confirmSelected()
  }

  constructor(
    public form: FormBuilder,
    private dialogRef: MatDialogRef<EditNoteComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) {
    dialogRef.disableClose = true

    this.confirmForm = this.form.group({
      reason: new FormControl(data.message, [Validators.required]),
    })
  }

  /* istanbul ignore next */
  focusOn(focus) {
    this.focus[focus] = !this.focus[focus]
  }

  /* istanbul ignore next */
  fieldHasErrorMessages(form, validation, fieldName) {
    const field = form.get(fieldName)

    return Boolean(field.hasError(validation.type) && (field.dirty || field.touched))
  }

  /* istanbul ignore next */
  fieldHasError(form, fieldName) {
    const field = form.get(fieldName)

    return Boolean(field.invalid && (field.dirty || field.touched))
  }

  /* istanbul ignore next */
  cancelSelected(): void {
    this.dialogRef.close({ confirmed: false, reason: null })
  }

  /* istanbul ignore next */
  confirmSelected(): void {
    this.data.message = this.confirmForm.controls.reason.value
    this.dialogRef.close({ confirmed: true, note: this.data })
  }
}
